import axios from '@/axios.config.js';

class ConsultationService {
    listConsultations(cancelToken) {
        return axios
            .get(`consultants/systems`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data
            });
    }

    createConsultation(cancelToken, consultation) {
        return axios
            .post('consultants/systems', consultation, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateConsultation(cancelToken, consultationId, consultation) {
        return axios
            .patch(`consultants/systems/${consultationId}`, consultation, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteConsultation(cancelToken, consultationId) {
        return axios
            .delete(`consultants/systems/${consultationId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listConsultationSchedules(cancelToken, consultationId) {
        return axios
            .get(`consultants/systems/${consultationId}/schedules`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data
            });
    }

    createConsultationSchedule(cancelToken, consultationId, consultationSchedule) {
        return axios
            .post(`consultants/systems/${consultationId}/schedules`, consultationSchedule, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateConsultationSchedule(cancelToken, consultationId, consultationScheduleId, consultationSchedule) {
        return axios
            .patch(`consultants/systems/${consultationId}/schedules/${consultationScheduleId}`, consultationSchedule, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteConsultationSchedule(cancelToken, consultationId, consultationScheduleId) {
        return axios
            .delete(`consultants/systems/${consultationId}/schedules/${consultationScheduleId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    addUserToConsultationSchedule(cancelToken, consultationId, consultationScheduleId) {
        return axios
            .post(`consultants/systems/${consultationId}/schedules/${consultationScheduleId}/users`, {}, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listConsultationSessions(cancelToken, userId) {
        return axios
            .get(`users/${userId}/consultations/sessions`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data
            });
    }

    createConsultationSession(cancelToken, userId, consultationSession) {
        return axios
            .post(`users/${userId}/consultations/sessions`, consultationSession, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateConsultationSession(cancelToken, userId, consultationSession) {
        return axios
            .patch(`users/${userId}/consultations/sessions/${consultationSession.id}`, consultationSession, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteConsultationSession(cancelToken, userId, consultationSessionId) {
        return axios
            .delete(`users/${userId}/consultations/sessions/${consultationSessionId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listConsultationExams(cancelToken, userId) {
        return axios
            .get(`users/${userId}/consultations/exams`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data
            });
    }

    createConsultationExam(cancelToken, userId, consultationExam) {
        return axios
            .post(`users/${userId}/consultations/exams`, consultationExam, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateConsultationExam(cancelToken, userId, consultationExam) {
        return axios
            .patch(`users/${userId}/consultations/exams/${consultationExam.id}`, consultationExam, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteConsultationExam(cancelToken, userId, consultationExamId) {
        return axios
            .delete(`users/${userId}/consultations/exams/${consultationExamId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

}

export default new ConsultationService();